import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ResolverService } from '../__common/resolver.service';
import { GuiFlowService } from '../__gui/gui-flow.service';

@Injectable({
  providedIn: 'root'
})
export class DataProviderService {

  subApps: any[] = [
    { id: 1, name: 'Migration', description: 'Information on migration', icon: 'flight',component: 'migration-helper' },
    { id: 2, name: 'Visa Process', description: 'Details on visa process', icon: 'assignment',component: 'visa-helper' },
    { id: 3, name: 'Transport', description: 'Transport options and tips', icon: 'directions_bus',component: 'transport-helper' },
    { id: 4, name: 'Budgets', description: 'Budget planning tools', icon: 'attach_money',component: 'budget-helper'},
    { id: 5, name: 'Health Insurance', description: 'Health insurance information', icon: 'healing',component: 'health-helper' }
  ];

  files = [
    {
      link: this.sanitizer.bypassSecurityTrustResourceUrl('path/to/file1.pdf'),
      uploadedAt: new Date(),
      notes: 'Certificado de antecedentes penales'
    },
    {
      link: this.sanitizer.bypassSecurityTrustResourceUrl('path/to/file2.pdf'),
      uploadedAt: new Date(),
      notes: 'File 3 notes'
    },
    {
      link: this.sanitizer.bypassSecurityTrustResourceUrl('path/to/file2.pdf'),
      uploadedAt: new Date(),
      notes: 'File 2 notes'
    },
    {
      link: this.sanitizer.bypassSecurityTrustResourceUrl('path/to/file2.pdf'),
      uploadedAt: new Date(),
      notes: 'File 2 notes'
    },
    {
      link: this.sanitizer.bypassSecurityTrustResourceUrl('path/to/file2.pdf'),
      uploadedAt: new Date(),
      notes: 'File 2 notes'
    },
    {
      link: this.sanitizer.bypassSecurityTrustResourceUrl('path/to/file2.pdf'),
      uploadedAt: new Date(),
      notes: 'File 2 notes'
    }
  ];

  mocks= {};

  clientAppsMock = [
    {
        "id": 1,
        "name": "Visado",
        "description": "Asistencia para obtener el visado de estudiantes. Requisitos, plazos enlaces para citas etc",
        "component": "visa-helper",
        "app": "studentVisa",
        "icon": "fas fa-passport",
        "imageUrl": "",
        "url": "visa",
        "disabled": 0,
        "visible": 1,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 2,
        "name": "Transporte",
        "description": "",
        "component": "transport-helper",
        "app": "transport",
        "icon": "",
        "imageUrl": "",
        "url": "transport",
        "disabled": 0,
        "visible": 1,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 3,
        "name": "Extranjería",
        "description": "",
        "component": "migration-helper",
        "app": "foreignOffices",
        "icon": "",
        "imageUrl": "",
        "url": "migration-app",
        "disabled": 0,
        "visible": 1,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 6,
        "name": "Seguro médico",
        "description": "",
        "component": "health-helper",
        "app": "healthInsurance",
        "icon": "fas fa-medkit",
        "imageUrl": "",
        "url": "health-app",
        "disabled": 0,
        "visible": 1,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 5,
        "name": "Vivienda",
        "description": "",
        "component": "accommodation-helper",
        "app": "accommodation",
        "icon": "fas fa-home",
        "imageUrl": "",
        "url": "accommodation",
        "disabled": 0,
        "visible": 1,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 12,
        "name": "Mi Proyecto",
        "description": "",
        "component": "my-project",
        "app": "myProject",
        "icon": "",
        "imageUrl": "",
        "url": "my-project-app",
        "disabled": 1,
        "visible": 0,
        "active": 0,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 9,
        "name": "Mapas",
        "description": "",
        "component": "google-map",
        "app": "maps",
        "icon": "",
        "imageUrl": "",
        "url": "maps-app",
        "disabled": 0,
        "visible": 0,
        "active": 0,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 4,
        "name": "Presupuestos",
        "description": "",
        "component": "budget-helper",
        "app": "budget-manager",
        "icon": "fas fa-hand-holding-usd",
        "imageUrl": "",
        "url": "budget",
        "disabled": 0,
        "visible": 0,
        "active": 0,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 7,
        "name": "Trabajo",
        "description": "",
        "component": "work-helper",
        "app": "work",
        "icon": "fas fa-briefcase",
        "imageUrl": "",
        "url": "work-app",
        "disabled": 0,
        "visible": 0,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 8,
        "name": "Links",
        "description": "",
        "component": "links-helper",
        "app": "links",
        "icon": "fas fa-paperclip",
        "imageUrl": "",
        "url": "",
        "disabled": 0,
        "visible": 0,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 10,
        "name": "Gastronomía",
        "description": "",
        "component": "food-helper",
        "app": "food",
        "icon": "fas fa-utensils",
        "imageUrl": "",
        "url": "",
        "disabled": 0,
        "visible": 0,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 11,
        "name": "Ocio",
        "description": "",
        "component": "culture-helper",
        "app": "activities",
        "icon": "fas fa-glass-cheers",
        "imageUrl": "",
        "url": "activities",
        "disabled": 0,
        "visible": 0,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    },
    {
        "id": 13,
        "name": "Legal",
        "description": "Bach Legal",
        "component": "legal-helper",
        "app": "bach-legal",
        "icon": "",
        "imageUrl": "",
        "url": "",
        "disabled": 0,
        "visible": 1,
        "active": 1,
        "activatedAt": "0000-00-00",
        "price": 0,
        "dueDate": "0000-00-00"
    }
  ];

  // SHOPIFY CONFIG AND VARIANTS
  shopifyProducts = [
    {
      id: 58,
      variantId: 51051369300271,
      name: 'Contratar seguro médico ASISA'
    }
  ]

  // SEGURO MEDICO
  mesesAnio = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' }
  ];

  duracionesSeguroMeses = [
    { label: '3 meses',value: 3 },
    { label: '6 meses',value: 6 },
    { label: '9 meses',value: 9 },
    { label: '12 meses',value: 12 },
  ]


  stepsSummarizedSeguroMedico = [
    {
      id: 1,
      title: 'Paso 1: Solicitud',
      description: 'Has completado el formulario indicando la duración de tu estancia y la universidad en la que estudiarás.'
    },
    {
      id: 4,
      icon: 'person',
      title: 'Paso 2: Ajuntar información',
      description: 'Se han registrado tus datos personales necesarios para la contratación.'
    },
    {
      id: 7,
      icon: 'upload_file',
      title: 'Paso 3: Esperar resolución',
      description: 'Has enviado los documentos requeridos como pasaporte y carta de aceptación.'
    },
    {
      id: 9,
      icon: 'email',
      title: 'Paso 4: Realizar pago',
      description: 'Estamos preparando y enviando el formulario y cuestionario de ASISA.'
    },
  ];

  stepsSeguroMedico = [
    {
      id: 1,
      icon: 'assignment',
      title: 'Paso 1: Datos de cobertura y universidad',
      description: 'Has completado el formulario indicando la duración de tu estancia y la universidad en la que estudiarás.'
    },
    {
      id: 2,
      icon: 'person',
      title: 'Paso 2: Información personal',
      description: 'Se han registrado tus datos personales necesarios para la contratación.'
    },
    {
      id: 3,
      icon: 'upload_file',
      title: 'Paso 3: Subida de documentación',
      description: 'Has enviado los documentos requeridos como pasaporte y carta de aceptación.'
    },
    {
      id: 4,
      icon: 'email',
      title: 'Paso 4: Esperando documentos de ASISA',
      description: 'Estamos preparando y enviando el formulario y cuestionario de ASISA.'
    },
    {
      id: 5,
      icon: 'edit_note',
      title: 'Paso 5: Descargar y completar',
      description: 'Deberás descargar y rellenar ambos documentos.'
    },
    {
      id: 6,
      icon: 'upload_file',
      title: 'Paso 6: Subir documentos rellenos',
      description: 'Subir ambos documentos por separado a la plataforma.'
    },
    {
      id: 7,
      icon: 'send',
      title: 'Paso 7: Solicitud enviada a ASISA',
      description: 'Hemos tramitado tu solicitud con la aseguradora. Estamos esperando su respuesta.'
    },
    {
      id: 8,
      icon: 'payment',
      title: 'Paso 8: Enlace de pago',
      description: 'Tu seguro ha sido aprobado, accede al enlace de pago seguro que te enviamos.'
    },
    {
      id: 9,
      icon: 'check_circle',
      title: 'Paso 9: Certificado de cobertura',
      description: 'La aseguradora está preparando el certificado de cobertura que podrás entregar en tu cita de solicitud del visado.'
    },
    {
      id: 10,
      icon: 'check_circle',
      title: 'Paso 10: Certificado de cobertura',
      description: 'Ya puedes descargar el certificado.'
    }
  ];

  constructor(private resolver: ResolverService,private sanitizer: DomSanitizer,private guiFlow: GuiFlowService) {
    this.mocks['getThisClientApps'] = this.clientAppsMock;
  }

  getClientDocuments(){
    return this.files;
  }

  createMocks(queryId){
    if(this.mocks[queryId]){
      let data = {
        props: [],
        records: this.mocks[queryId]
      }
      this.resolver.saveDataToLocalCache(queryId,data);
    }
  }

  getMocks(queryId){
    return this.mocks[queryId];
  }

  getClientApps(id){
    //GET
    this.resolver.getBackendDataForQueryId('getThisClientApps',true,id);
  }

  getClientChecklists(id){
    this.resolver.getBackendDataForQueryId('clientChecklists',true,id);
  }

  getClientTools(id){
    this.resolver.getBackendDataForQueryId('getClientTools',true,id);
  }

  resolveDep(){
    return this.resolver.getDependency('clientChecklists');
  }

  getThisClientInteractions(){
    this.resolver.getClientInteractions(true);
  }

  getVisibleApps(){
    let res = [];
    if(this.resolver.getDependency('getThisClientApps').records){
      for(let section of this.resolver.getDependency('getThisClientApps').records){
        if(section.visible == '1'){
          res.push(section);
        }
      }
      return res;
    }else{
      return [];
    }
  }

  getImageUrl(appName){
    let imageId;
    switch(appName){
      case 'studentVisa':
        imageId = '10399059-2cae-4a05-faa8-9754e746e600';
        break;
      case 'transport':
        imageId = 'f6fa70c1-9806-41be-d049-c18ab688d800';
        break;
        // Photo by <a href="https://unsplash.com/@yapics?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Leon Seibert</a> on <a href="https://unsplash.com/photos/person-writing-on-white-form-paper-9i5eqBarv-k?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
      case 'foreignOffices':
        imageId = 'f95eab35-2a3c-4a11-d193-dd86ebc64800';
        break;
      case 'accommodation':
        // Photo by <a href="https://unsplash.com/@rodriguezedm?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Eduardo Rodriguez</a> on <a href="https://unsplash.com/photos/white-concrete-building-under-blue-sky-during-daytime-SgfN_bmO4rE?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
        imageId = 'e53c15ed-7343-47c6-c453-6a4212c56300';
        break;
      case 'healthInsurance':
        imageId = '0539da1d-067c-4845-c711-9db70b7e9500';
        break;
      case 'budget-manager':
        imageId = 'b906c417-5a87-4bfa-ff8d-4c8735a40300';
        break;
      case 'maps':
        imageId = 'b906c417-5a87-4bfa-ff8d-4c8735a40300';
        break;
      case 'myProject':
        imageId = 'b906c417-5a87-4bfa-ff8d-4c8735a40300';
        break;
      case 'bach-legal':
        imageId = 'facdb2a5-4e8b-4378-6e52-0d0999a73700';
        break;
      default:
        break;
    }
    return this.guiFlow.getImage(imageId,'public');
  }

  getMesesAnio(){
    return this.mesesAnio;
  }

  getDuracionesSeguroMeses(){
    return this.duracionesSeguroMeses;
  }

  getStepsSeguroMedico(){
    return this.stepsSeguroMedico;
  }

  getStepsSummarizedSeguroMedico(){
    return this.stepsSummarizedSeguroMedico;
  }
  

  // SHOPIFY
  getShopifyProductValueByField(fieldToGet: string, matchField: string, matchValue: any): any {
    const product = this.shopifyProducts.find(p => p[matchField] === matchValue);
    return product ? product[fieldToGet] : null;
  }
  
}
